import { useEffect } from "react";
import { useSelector } from "react-redux";
import wuloojMark from "assets/images/superadmin/wulooj-mark.png";
import {
  applyTenantBranding,
  clearTenantBranding,
  getTenantBrandingFromStorage,
  normalizeTenantBranding,
  saveTenantBrandingToStorage,
} from "utils/tenantBranding";

const TenantThemeBridge = () => {
  const accountType = useSelector((state) => state.Login?.accountType);
  const accountScope = useSelector((state) => state.Login?.accountScope);
  const tenantBranding = useSelector(
    (state) => state.Login?.authUser?.tenantBranding || null
  );

  useEffect(() => {
    const isSuperAdmin =
      accountScope === "super_admin" || accountType === "superadmin";
    if (isSuperAdmin) {
      clearTenantBranding();
      return;
    }

    const storedBranding = getTenantBrandingFromStorage();
    if (storedBranding) {
      applyTenantBranding(storedBranding);
      return;
    }

    if (tenantBranding) {
      const normalized = normalizeTenantBranding(tenantBranding);
      saveTenantBrandingToStorage(normalized);
      applyTenantBranding(normalized);
    }
  }, [accountScope, accountType, tenantBranding]);

  useEffect(() => {
    const isSuperAdmin =
      accountScope === "super_admin" || accountType === "superadmin";
    if (isSuperAdmin) return undefined;

    const link =
      document.querySelector("link[rel='icon']") ||
      Object.assign(document.createElement("link"), { rel: "icon" });
    if (!link.parentNode) document.head.appendChild(link);

    const prevHref = link.getAttribute("href") || "";
    link.href = wuloojMark;

    return () => {
      if (prevHref) link.setAttribute("href", prevHref);
    };
  }, [accountScope, accountType]);

  return null;
};

export default TenantThemeBridge;
